import { ImgHTMLAttributes, useState } from "react";
import AvatarImage from "../../../assets/img/avatar.png";
import styles from "./Avatar.module.scss";

type AvatarSize = "small" | "medium" | "large";

interface AvatarProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> {
  size?: AvatarSize;
  src?: string;
  alt?: string;
}

const Avatar = ({
  size = "medium",
  src,
  alt = "Avatar",
  className,
  ...props
}: AvatarProps) => {
  const [hasError, setHasError] = useState(false);
  const sizeClass = styles[size];

  const handleImageError = () => {
    setHasError(true);
  };

  const imageSrc = !src || hasError ? AvatarImage : src;

  return (
    <div
      className={`${styles.avatar} ${sizeClass} ${className || ""}`}
      role="img"
      aria-label={alt}
    >
      <img
        src={imageSrc}
        alt={alt}
        className={styles.image}
        onError={handleImageError}
        {...props}
      />
    </div>
  );
};

export default Avatar;
